import { render, staticRenderFns } from "./DatesDialog.vue?vue&type=template&id=457e5d6e&scoped=true&"
import script from "./DatesDialog.vue?vue&type=script&lang=js&"
export * from "./DatesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e5d6e",
  null
  
)

export default component.exports